import './navigation.js';
import './skip-link-focus-fix.js'
(( $ ) => {


	$(document).ready( () => {

		/**
		 * toggles hamburger icon when clicked
		 */
		 $('#menu-toggle button').click(function() {
				$('i').toggleClass("fa-times", 1000);
				// $('.nav-menu').toggleClass("slideOut");
				// $('#menu-toggle button').addClass('slideleft');
				$(this).find('p').text(function(i, text){
          return text === "Sulje valikko" ? "Valikko" : "Sulje valikko";
      })
		 });

		 /**
 		 * pauses video on mobile to certain point
 		 */
		 var video = $(".hero-video video");
		 if (video.length) {
		 function videoHandler(){
    	video[0][ $(window).width()<960 ? "pause" : "play" ]();
				if ($(window).width() < 960) {
					video[0].currentTime = 5;
				}
			}

			$(window).on("resize load", videoHandler);
		}

		 /**
 		 * functionality to accordions
 		 */

		  $('.accordion-body').hide();
			$('.accordion-body').eq(0).show();

				$('.accordion-header').eq(0).find('i').toggleClass("fa-chevron-down", 500);


		 $('.accordion-header h4').click(function() {
				$(this).find('i').toggleClass("fa-chevron-down", 500);
				$(this).parent().parent().find('.accordion-body').slideToggle( "fast", function() {
    			// Animation complete.
  			});
		 });

		 /**
			 * functionality to post archive list
			 */

		//	$('.archive-year').eq(0).find('.archive-month').show();
		 $('.archive-month').click(function() {
			 var target = $(this).attr("id");
				$(this).find('i').toggleClass("fa-chevron-down", 500);
				$('.'+target).slideToggle( "fast", function() {
 				 // Animation complete.
 			 });

		 });

 // show number of articles per month
	 var months = $('.archive-month').length;

	 for (var i = 0; i < months; i++) {
		  var  div = $('.archive-month').eq(i);
			var target = $(div).attr("id");
			var titleLength = $('.'+target).length;
			console.log(titleLength);
			$('#'+target).find('.count').append(titleLength);
		}
// });


		 // somefeed filter functionality

		 $('#btn-all').addClass('bg-blue');
			$('.some-card').slice(0,3).addClass('active-card');

		 $('.filters button').click(function() {
			 var target = $(this).attr("name");
			 if (target == 'all') {
				 $('.some-warning').hide();
				 $('.some-card').removeClass('active-card');
				 $('.filters button').removeClass('bg-blue');
				  $('#btn-all').addClass('bg-blue');
				 $('.some-card').slice(0,3).addClass('active-card');
			 } else {

			 $('.filters button').removeClass('bg-blue');

			 	$('.some-card').removeClass('active-card');

				$('.'+target).parent().addClass('active-card');

				if ($('.active-card').length) {
					$('.some-warning').hide();
				} else {
					$('.some-warning').show();
				}

				$(this).addClass('bg-blue');

			}
		 });

		 // if wysiwyg has iframe, add wrapper class to paragraph
		 $('.block-wysiwyg p iframe').parent().addClass('iframe-wrapper');
	});

	// changing fare calculator view
	$('.btn-fare').click(function() {
				$('.btn-fare').not(this).removeClass('bg-blue');
				$(this).addClass('bg-blue');

			var target = $(this).attr("rel");

		$('.fare-view').not('#'+target).slideUp( "fast", function() {
		 // Animation complete.
	 });
		 $('#'+target).slideDown( "fast", function() {
			// Animation complete.
		});

	});



	/* optional triggers

	$(window).load(() => {

	});

	$(window).resize(() => {

	});

	*/


} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/app.js